/**
 * package: com.inq.ui
 * class: TextInput
 * @extends com.inq.ui.AbstractTextInput 
 * @constructor
 */
com.inq.ui.TextInput = function(_id) {
	com.inq.ui.AbstractTextInput.call(this,_id);
	this._div.innerHTML = "<textarea style=\"height:100%;width:100%\"></textarea>";
	/** @type {HTMLElement} */
	this._text = this._div.getElementsByTagName("TEXTAREA")[0];
	this.setupInput(this._text);
	if (this._input) {
		/* Set the container in the input element for support of the getContainer method below */
		this._input["container"] = this;
	}

	/** @type {Integer}
	 *  @private
	 */
	this._offsetTop = 0;
	/** @type {string} */
	this._previousValue = "";
};
$hxClasses.extend(com.inq.ui.AbstractTextInput, com.inq.ui.TextInput, "com.inq.ui.TextInput");

/**
 * getContainer
 * Get the TextInput container from the element
 * This is needed for setFocusOnInputField method in SkinControl
 *
 * $type TFun([{ name => element, t => TDynamic(null), opt => false }],TInst(com.inq.ui.TextInput,[]))
 * public static function getContainer(element:Dynamic):TextInput
 * @public
 * @static
 * @param {null}  element - element from which to get TextInput container 
 * @return {com.inq.ui.TextInput} - TextInput for the element or null;
 */
com.inq.ui.TextInput.getContainer = function(element) {
	return element["container"];
};


/**
 * buildStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * override 	private function buildStyle():Void
 * @override
 * @private
 * @this com.inq.ui.TextInput
 * @return {void}
 */
com.inq.ui.TextInput.prototype.buildStyle = function() {

	// Android need this to have correct keyCode in keydown event.
	if(com.inq.utils.Capabilities.isAndroid()) {
		this._input.setAttribute("autocomplete","off");
	}
	com.inq.ui.AbstractTextInput.prototype.buildStyle.call(this);
	/* Call super class build style */
	if(this.styles.value != null) this.setText(this.evaluateString(this.styles.value));/* set the text input area with the evaluated text */
	if(this.styles.text != null) this.setText(this.evaluateString(this.styles.text));/* set the text input area with the evaluated text */
	/** @type {?string} */
	var textStyle = this.getStyle("title");
	if(textStyle != null){
		this._text.title=textStyle;
	}

};

/**
 * applyAttributeMap
 *
 * @override
 */
com.inq.ui.TextInput.prototype.applyAttributeMap = function () {
	for (var aKey in this.attributeMap) {
		if (this.attributeMap.hasOwnProperty(aKey)) {
			switch (aKey) {
				case "aria-live":
				case "aria-hidden":
					this._div.setAttribute(aKey, this.attributeMap[aKey]);
					break;
				default:
					this.getPrimaryObject().setAttribute(aKey, this.attributeMap[aKey]);
			}
		}
	}
}


/**
 * getPrimaryObject
 *
 * @override
 */
com.inq.ui.TextInput.prototype.getPrimaryObject = function(){
	return	this._input;
}
/**
 * this function calcualtes the offset top value between input and stage div
 * @return {Integer}
 */
com.inq.ui.TextInput.prototype.getOffsetTop = function(){
	if(this._offsetTop!=0)
		return this._offsetTop;
	this._offsetTop = com.inq.flash.client.chatskins.ScrollMonitor.getOffsetTopToStage(this._input);
	return	this._offsetTop;
}

/**
 * applyStyle - We override the applyStyle for android phone v4.0.4
 *	Due to a rendering problem in the default web browser, the input box is rendered INVALID_MODIFICATION_ERR
 *    we override the element to be an fixed positioned textarea.  This fixes this quirk
 *
 * @override
 * @private
 * @this com.inq.ui.TextInput
 * @return {void}
 */
com.inq.ui.TextInput.prototype.applyStyle = function() {
	com.inq.ui.AbstractTextInput.prototype.applyStyle.call(this); /* Super call */

	if (com.inq.utils.Capabilities.isPhone() &&
		com.inq.utils.Capabilities.isAndroid("Android 4.0.4;")) {
		/** @type {number} */
		var left = this.getStyle("left");
		/** @type {number} */
		var top = this.getStyle("top");
		/** @type {number} */
		var bottom = this.getStyle("bottom");
		/** @type {number} */
		var right = this.getStyle("right");
		/** @type {number} */
		var width = this.getStyle("width");
		/** @type {number} */
		var height = this.getStyle("height");
		
		this._input.style.top =  (top != null) ? top + "px" : null;
		this._input.style.bottom =  (bottom != null) ? bottom + "px" : null;
		this._input.style.right =  (right != null) ? right + "px" : null;
		this._input.style.left =  (left != null) ? left + "px" : null;
		this._input.style.width =  (width != null) ? width + "px" : null;
		this._input.style.height =  (height != null) ? height + "px" : null;
		this._input.style.position =  "fixed";
	} else if (com.inq.utils.Capabilities.isIphone()) {
		this._input.style.minHeight = this._div.clientHeight+"px";
	}
};

/**
 * setText - Setter for textarea value.
 * Also updates the saved previous value of this field for restoring it in some cases.
 *
 * @private
 * @this com.inq.ui.TextInput
 * @param {string} val
 * @param {string=} previousVal - optional parameter to save the previous value to restore it later
 * @return {void}
 */
com.inq.ui.TextInput.prototype.setText = function(val, previousVal) {
	if (this._text.value != val) {
		if (previousVal || previousVal == "") {
			this._previousValue = previousVal;
		} else {
			this._previousValue = this._text.value;
		}
		this._text.value = val;
	}
};

/**
 * get - getter for text *
 * @public
 * @return {String}
 */
com.inq.ui.TextInput.prototype.getText = function() {
	return this._text.value;
};

/**
 * getHtmlLabelObject - returns appropriate object to label for.
 *
 * public function getHtmlLabelObject():Object
 * @public
 * @this com.inq.ui.TextInput
 * @return {Object}
 */
com.inq.ui.TextInput.prototype.getHtmlLabelObject = function() {
	/** @type {?Object} */
	var labelObjet = null;
	if(typeof this._input != "undefined") {
		labelObjet = this._input
	} else {
		if(typeof this._div != "undefined") {
			labelObjet = this._div.firstChild;
		}
	}
	return labelObjet;
};

com.inq.ui.TextInput.prototype.restorePreviousValue = function() {
	this.setText(this._previousValue);
};